import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  sectionRoot: {
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    marginTop: '16px',
    alignItems: 'center',
    borderBottom: '1px solid #C6C6C6',
    paddingBottom: '8px'
  },

  sectionLabels: {
    fontSize: theme.size.sm,
    paddingRight: 16
  },

  input: {
    border: 'none',
    height: '31px',
    padding: '0',
    outline: 'none',
    background: 'transparent',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    flex: 1
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  result: {
    borderRadius: '8px',
    height: '48px',
    padding: '0 12px',
    fontSize: theme.size.base,

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  smsResult: {
    cursor: 'inherit',
    color: '#3C425B'
  },

  smsValue: {
    color: 'grey',
    fontSize: theme.size.sm,
    cursor: 'inherit',
    marginLeft: '8px'
  },

  flag: {
    marginLeft: '8px'
  },

  newContact: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.base,
    height: '48px',
    cursor: 'pointer',
    padding: '0 12px',
    borderRadius: '8px',

    '&:hover': {
      background: '#F5F6F8'
    },

    '& strong': {
      margin: '0px 4px'
    }
  },

  pillsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    flex: 1
  },

  pill: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    marginRight: '5px',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '8px',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'default',
    fontSize: theme.size.base,
    color: '#1F1F1F',

    '& svg': {
      cursor: 'pointer',
      paddingLeft: 6
    },

    '& .selected-flag': {
      paddingLeft: '3px'
    },

    '& .form-control': {
      paddingLeft: '38px'
    }
  },

  pillUserName: {
    marginBottom: 4
  },

  extraChannelsLabel: {},

  extraChannelsResults: {
    marginTop: 10
  },

  extraPadding: {
    padding: '0px 2px'
  },

  noResults: {
    color: 'grey',
    padding: '0 12px',
    borderRadius: '8px',
    cursor: 'default',
    height: '48px',
    display: 'flex',
    alignItems: 'center'
  },

  newUserNameInput: {
    border: '0',
    outline: '0'
  },

  channelInput: {
    color: 'grey'
  },

  flagSize: {
    height: '11px'
  },

  flagHolder: {
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
